var _filter, _filter2, _filter3, _pattern, _rect, _rect2, _circle, _circle2, _circle3, _rect3, _g, _g2, _text, _rect4, _rect5, _text2, _text3, _text4, _text5, _text6, _rect6, _g3, _g4, _rect7, _rect8, _rect9, _circle4, _circle5, _circle6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _line, _line2, _line3, _line4, _line5, _line6, _rect10, _text14, _text15, _text16, _rect11, _text17, _text18, _text19, _rect12, _text20, _text21, _text22, _g5, _rect13, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 630",
    fontFamily: "'Segoe UI', Arial, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "coverBg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0a0a14"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40%",
    style: {
      stopColor: "#0f1029"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1a0a2e"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "greenGlow",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#22c55e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#10b981"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "purpleGlow",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6c63ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#a855f7"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "redToGreen",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ef4444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#f59e0b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#22c55e"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bar1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ef4444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f97316"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bar2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#8b5cf6"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bar3",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#22c55e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#10b981"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "coverGlow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "softGlow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "textShadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 2,
    stdDeviation: 4,
    floodColor: "#000",
    floodOpacity: 0.5
  }))), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 40,
    height: 40,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40 0 L 0 0 0 40",
    fill: "none",
    stroke: "#1e293b",
    strokeWidth: 0.5,
    opacity: 0.3
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 630,
    fill: "url(#coverBg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 630,
    fill: "url(#grid)",
    opacity: 0.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 150,
    r: 200,
    fill: "#6c63ff",
    opacity: 0.03,
    filter: "url(#softGlow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 500,
    r: 180,
    fill: "#22c55e",
    opacity: 0.03,
    filter: "url(#softGlow)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1100,
    cy: 550,
    r: 120,
    fill: "#a855f7",
    opacity: 0.04,
    filter: "url(#softGlow)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 4,
    fill: "url(#redToGreen)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(105, 90)",
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "50,0 93.3,25 93.3,75 50,100 6.7,75 6.7,25",
    fill: "none",
    stroke: "#22c55e",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50,10 85,30 85,70 50,90 15,70 15,30",
    fill: "none",
    stroke: "#22c55e",
    strokeWidth: 1.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1020, 400)",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "40,0 74.6,20 74.6,60 40,80 5.4,60 5.4,20",
    fill: "none",
    stroke: "#a855f7",
    strokeWidth: 2.5
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 280,
    fill: "#22c55e",
    fontSize: 160,
    fontWeight: 900,
    opacity: 0.08,
    filter: "url(#softGlow)"
  }, "8x")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 130,
    width: 200,
    height: 32,
    rx: 16,
    fill: "#22c55e",
    opacity: 0.15
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 130,
    width: 200,
    height: 32,
    rx: 16,
    fill: "none",
    stroke: "#22c55e",
    strokeWidth: 1,
    opacity: 0.5
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 152,
    textAnchor: "middle",
    fill: "#4ade80",
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: 2
  }, "\u2B22 NODE.JS PERF")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 220,
    fill: "#f1f5f9",
    fontSize: 52,
    fontWeight: 800,
    filter: "url(#textShadow)",
    letterSpacing: -1
  }, "\n    From 10K to 86K\n  ")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 285,
    fill: "#e2e8f0",
    fontSize: 46,
    fontWeight: 700,
    filter: "url(#textShadow)",
    letterSpacing: -0.5
  }, "\n    Requests Per Second\n  ")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 340,
    fill: "#94a3b8",
    fontSize: 22,
    fontWeight: 400
  }, "\n    A deep dive into Node.js performance optimization\n  ")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 372,
    fill: "#94a3b8",
    fontSize: 22,
    fontWeight: 400
  }, "\n    with ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#a78bfa",
    fontWeight: 600
  }, "Clustering"), " &amp; ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#6ee7b7",
    fontWeight: 600
  }, "Fastify"))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 400,
    width: 100,
    height: 3,
    rx: 2,
    fill: "url(#purpleGlow)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 425)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 85,
    height: 30,
    rx: 6,
    fill: "#1e293b",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 20,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 12,
    fontWeight: 600
  }, "Express"), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 0,
    width: 80,
    height: 30,
    rx: 6,
    fill: "#1e293b",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 20,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 12,
    fontWeight: 600
  }, "Fastify"), /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 0,
    width: 90,
    height: 30,
    rx: 6,
    fill: "#1e293b",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 20,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 12,
    fontWeight: 600
  }, "Clustering"), /*#__PURE__*/React.createElement("rect", {
    x: 285,
    y: 0,
    width: 105,
    height: 30,
    rx: 6,
    fill: "#1e293b",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 337,
    y: 20,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 12,
    fontWeight: 600
  }, "Autocannon"), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 0,
    width: 120,
    height: 30,
    rx: 6,
    fill: "#1e293b",
    stroke: "#334155",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 20,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 12,
    fontWeight: 600
  }, "Performance"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 485)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 14,
    r: 18,
    fill: "#1e293b",
    stroke: "#6c63ff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 18,
    y: 20,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 16,
    fontWeight: 700
  }, "A"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 12,
    fill: "#cbd5e1",
    fontSize: 14,
    fontWeight: 600
  }, "Aqib"), /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 30,
    fill: "#64748b",
    fontSize: 12
  }, "Performance Engineer \u2022 February 2026"))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 110,
    width: 440,
    height: 400,
    rx: 16,
    fill: "#0d0d1a",
    stroke: "#1e293b",
    strokeWidth: 1.5,
    opacity: 0.9
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 110,
    width: 440,
    height: 50,
    rx: 16,
    fill: "#111127"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 144,
    width: 440,
    height: 16,
    fill: "#111127"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 708,
    cy: 135,
    r: 5,
    fill: "#ef4444"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 726,
    cy: 135,
    r: 5,
    fill: "#f59e0b"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 744,
    cy: 135,
    r: 5,
    fill: "#22c55e"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 900,
    y: 140,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 12,
    fontWeight: 600
  }, "performance-benchmark.js")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 710,
    y: 200,
    fill: "#475569",
    fontSize: 10
  }, "100K")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 714,
    y: 250,
    fill: "#475569",
    fontSize: 10
  }, "80K")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 714,
    y: 300,
    fill: "#475569",
    fontSize: 10
  }, "60K")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 714,
    y: 350,
    fill: "#475569",
    fontSize: 10
  }, "40K")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 714,
    y: 400,
    fill: "#475569",
    fontSize: 10
  }, "20K")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 722,
    y: 450,
    fill: "#475569",
    fontSize: 10
  }, "0")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 745,
    y1: 195,
    x2: 1090,
    y2: 195,
    stroke: "#1e293b",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 745,
    y1: 245,
    x2: 1090,
    y2: 245,
    stroke: "#1e293b",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 745,
    y1: 295,
    x2: 1090,
    y2: 295,
    stroke: "#1e293b",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 745,
    y1: 345,
    x2: 1090,
    y2: 345,
    stroke: "#1e293b",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 745,
    y1: 395,
    x2: 1090,
    y2: 395,
    stroke: "#1e293b",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 745,
    y1: 445,
    x2: 1090,
    y2: 445,
    stroke: "#1e293b",
    strokeWidth: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 418,
    width: 80,
    height: 27,
    rx: 4,
    fill: "url(#bar1)"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 412,
    textAnchor: "middle",
    fill: "#fca5a5",
    fontSize: 11,
    fontWeight: 700
  }, "10.8K")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 480,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 9
  }, "Express")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 492,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 8
  }, "Single")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 900,
    y: 313,
    width: 80,
    height: 132,
    rx: 4,
    fill: "url(#bar2)"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 940,
    y: 307,
    textAnchor: "middle",
    fill: "#93c5fd",
    fontSize: 11,
    fontWeight: 700
  }, "52.6K")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 940,
    y: 480,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 9
  }, "Express")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 940,
    y: 492,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 8
  }, "+ Cluster")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 229,
    width: 80,
    height: 216,
    rx: 4,
    fill: "url(#bar3)",
    filter: "url(#coverGlow)"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 1060,
    y: 223,
    textAnchor: "middle",
    fill: "#4ade80",
    fontSize: 11,
    fontWeight: 700
  }, "86.5K")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 1060,
    y: 480,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 9
  }, "Fastify")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 1060,
    y: 492,
    textAnchor: "middle",
    fill: "#64748b",
    fontSize: 8
  }, "+ Cluster")), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M862,430 C920,380 980,350 1020,240",
    fill: "none",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeDasharray: "5,3",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 195,
    width: 48,
    height: 26,
    rx: 13,
    fill: "#fbbf24",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 950,
    y: 195,
    width: 48,
    height: 26,
    rx: 13,
    fill: "none",
    stroke: "#fbbf24",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 974,
    y: 213,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontSize: 13,
    fontWeight: 800
  }, "8x \u2191"))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 626,
    width: 1200,
    height: 4,
    fill: "url(#purpleGlow)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,630 L0,580 Q0,570 10,570 L60,570",
    fill: "none",
    stroke: "#6c63ff",
    strokeWidth: 1,
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1200,630 L1200,580 Q1200,570 1190,570 L1140,570",
    fill: "none",
    stroke: "#6c63ff",
    strokeWidth: 1,
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,50 Q0,60 10,60 L60,60",
    fill: "none",
    stroke: "#22c55e",
    strokeWidth: 1,
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1200,0 L1200,50 Q1200,60 1190,60 L1140,60",
    fill: "none",
    stroke: "#22c55e",
    strokeWidth: 1,
    opacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCover);
export default __webpack_public_path__ + "static/media/cover.46040b8a5ecc9bd52c60e19e47576122.svg";
export { ForwardRef as ReactComponent };